import Authentication from "@domain/core/auth/Authentication";
import type { MessageResponse } from "@domain/models/http/Response";
import {
  type AuthenticatedUser,
  type ChangePasswordPayload,
  type ForgotPasswordPayload,
  type LoginCredentials,
  type LoginResponse,
  currentUserResponseSchema,
  loginResponseSchema,
} from "@domain/models/User";
import type IAuthRepository from "@domain/ports/auth/IAuthRepository";

import Service from "../Service";
import { tokenStorage } from "./tokenStorage";

const readMessage = (payload: Partial<MessageResponse> | undefined) =>
  typeof payload?.message === "string" ? payload.message : null;

export class AuthService extends Service implements IAuthRepository {
  public constructor(baseURL?: string) {
    super(baseURL);
  }

  public async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await this.api.post("/login", credentials);

    return loginResponseSchema.parse(response.data);
  }

  public async fetchCurrentUser(): Promise<AuthenticatedUser> {
    const response = await this.api.get("/me");

    return currentUserResponseSchema.parse(response.data);
  }

  public async logout(): Promise<void> {
    await this.api.post("/logout");
  }

  public async forgotPassword(
    payload: ForgotPasswordPayload,
  ): Promise<string | null> {
    const response = await this.api.post<MessageResponse>(
      "/forgot-password",
      payload,
    );

    return readMessage(response.data);
  }

  public async changePassword(
    payload: ChangePasswordPayload,
  ): Promise<string | null> {
    const response = await this.api.put<MessageResponse>(
      "/me/password",
      payload,
    );

    return readMessage(response.data);
  }
}

export const authentication = new Authentication(
  new AuthService(),
  tokenStorage,
);
